"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var SEA = function SEA(props) {
  var size = props.size;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    width: size,
    height: size,
    preserveAspectRatio: "xMidYMid slice",
    clipRule: "evenodd",
    fillRule: "evenodd",
    viewBox: "0 0 560 400",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "m401.769 250.871c-15.561-2.671-31.328-3.977-47.119-3.902h-216.389c-13.506 0-27.611 0-34.514-11.105-7.503-11.105-3.301-22.209 8.704-44.118.9-1.801 38.116-71.429 38.116-71.429 2.291 2.796 4.799 5.405 7.503 7.803 3.902 3.001 7.803 4.502 18.007 4.502 18.308 0 136.856-.3 138.057-.3 24.01 0 48.32 2.401 63.926 19.808 8.403.9 34.514 4.202 56.423 14.706 12.605 6.002 21.009 15.006 24.31 26.111.86 3.434 1.263 6.965 1.2 10.504 0 10.504-3.902 22.209-11.405 34.514-16.507 25.511-31.513 34.514-32.113 34.814-5.37 3.904-11.695 6.288-18.308 6.903 4.654-5.417 8.311-11.615 10.804-18.308 2.701-9.304-7.203-10.504-7.203-10.504z",
    fill: "#fff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m431.782 172.539c-24.91-12.005-56.723-14.406-56.723-14.406-13.806-17.107-37.215-19.508-60.925-19.508 0 0-119.449.3-138.057.3-21.609 0-23.71-8.704-23.71-8.704l-29.112 54.322h75.331c23.71 0 24.91-2.401 40.517-14.106 16.807-12.305 30.012-16.507 45.919-16.507 15.606 0 26.111 3.301 43.818 11.105 17.407 7.803 26.711 11.705 37.215 7.203 0 0-8.103 11.105-33.014.6-24.91-10.204-31.513-12.605-46.819-12.605-14.706 0-31.813 7.203-53.122 28.512l25.511 20.408s-6.002 9.304-9.904 15.006-3.601 9.604-1.501 12.605c2.101 2.701 4.802 3.902 14.106 3.902h93.338c16.197.025 32.363 1.431 48.32 4.202 24.01 4.802 8.403 24.91 8.403 24.91s16.207-10.504 31.813-35.415c17.707-27.611 13.205-50.121-11.405-61.825z",
    fill: "#024"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m387.964 176.74c-11.105-2.701-1.501-9.004-1.501-9.004-10.767 2.296-19.686 9.862-23.71 20.108l-.9 1.501c-9.004 18.007-17.107 17.107-32.413 17.107h-26.111c-21.309 0-31.213 10.504-41.417 28.512h12.005c11.105-16.507 19.208-20.709 41.117-21.909 49.52 0 88.837 14.106 109.845 24.91 29.712-49.821-14.406-57.924-36.915-61.225zm-92.138 57.924c5.402-8.403 16.807-11.105 34.814-10.204 45.019 2.701 70.829 11.405 90.637 18.908-24.61-14.406-68.728-24.91-99.341-24.91-14.706 0-27.911 2.701-35.415 16.207h9.304zm48.019-49.52c-5.702 8.403-13.506 11.105-35.415 9.604-25.21-1.801-18.608-12.605-15.907-17.707.9-1.501 2.101-4.202 3.601-6.603-19.508-1.2-33.614 13.806-33.614 13.806 14.406 14.406 24.01 15.907 37.215 15.907h24.61c22.809 0 28.212-10.204 30.312-15.006-3.576.6-7.228.6-10.804 0z",
    fill: "#fff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m332.741 182.743c-.528-.118-1.035-.32-1.501-.6-2.464 2.606-6.057 3.842-9.604 3.301-5.102-.6-7.803-4.202-6.303-7.803.063-.638.268-1.253.6-1.801l-7.503-2.701c-5.102 8.103-7.803 13.506 9.604 15.006 10.804.9 13.806-.9 16.207-4.802l-1.501-.6z",
    fill: "#69be28"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m244.805 213.956c-9.004 15.606-12.605 19.208-6.303 26.711h-100.241c-15.006 0-24.61-.6-29.412-8.103s-3.902-14.406 9.004-37.816h85.235c14.706 0 18.608.9 26.411 6.903 8.103 6.303 15.306 12.305 15.306 12.305z",
    fill: "#a5acaf"
  }));
};

SEA.propTypes = {
  size: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])
};
SEA.defaultProps = {
  size: '100'
};
var _default = SEA;
exports["default"] = _default;